import axios from '../axios'
import { ApiController } from './types'

const base = '/invitations'

const apiController: ApiController = {
    getInvitations: async ({ params, networkIds }) => {
        return await axios
            .get(`${base}?networkIds=${networkIds}`)
            .then((response) => response.data)
    },
    createInvitation: async (request) => {
        return await axios
            .post(`${base}`, request)
            .then((response) => response.data)
    },
}

export default apiController